import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class dragAndDropSymbol {
    public subscriber: Subject<string> = new Subject<string>();
}